<template>
  <div class="app flex-row align-items-center">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="10">
          <b-card-group>
            <b-card no-body class="p-2">
              <b-card-body>
                <b-form>
                  <div class="text-center mb-2">
                    <img src="../../../public/img/logo-mfu.png" height="200px"/>
                  </div>
                  <!--<h2>Login</h2>-->
                  <p class="text-muted text-center font-4xl">Course Withdraw Online</p>
                  <b-input-group class="mb-3">
                    <b-input-group-prepend><b-input-group-text><i class="icon-user"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="text" class="form-control" placeholder="Username" autocomplete="username email" v-model="username"/>
                  </b-input-group>
                  <b-input-group class="mb-4">
                    <b-input-group-prepend><b-input-group-text><i class="icon-lock"></i></b-input-group-text></b-input-group-prepend>
                    <b-form-input type="password" v-on:keydown.enter="onAUthen()" class="form-control" placeholder="Password" autocomplete="current-password" v-model="password"/>
                  </b-input-group>

                  <p class="text-muted font-lg">Username / Password <br>use the same as the registration system</p>
                  <b-row>
                    <b-col cols="6" class="text-right">
                    </b-col >
                    <b-col cols="6">
                      <b-button variant="primary" class="w-100 text-white"  @click="onAUthen()">Login</b-button>
                    </b-col>
                  </b-row>
                </b-form>
              </b-card-body>
            </b-card>
            <b-card no-body class="text-white bg-mfu py-5 d-md-down-none" >
              <b-card-body>
                <div class="ql-editor" v-html="message"></div>
              </b-card-body>
            </b-card>
          </b-card-group>
        </b-col>
      </b-row>
      <b-modal
              :header-bg-variant="this.dialog.type"
              header-text-variant="light"
              :class="this.dialog.style"
              v-model="this.dialog.status"
              @ok="actionDialog()"
              :ok-variant="this.dialog.type"
              ok-only>
        {{this.dialog.message}}
      </b-modal>
    </div>
  </div>
</template>

<script>
  import Service from "../../service/api"
  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'
  import store from '@/store/store'
  export default {
    name: 'Login',
    data () {
      return {
        // username:'6231501001',
        // password:'QZCXEVJP',
        message:"First Semester 2023 <br><br> Monday 16 Oct 2023 8.00 AM - Thursday 2 Nov 2023, 4:00 PM",
        username:'',
        password:'',

        dialog : {
          message : '',
          type : 'danger',
          style : 'modal-danger',
          status : false,

        },
        playerOptions: {
          autoplay: true,
          controls: true,
          controlBar: {
            timeDivider: false,
            durationDisplay: false
          }
          // poster: 'https://surmon-china.github.io/vue-quill-editor/static/images/surmon-5.jpg'
        }
      }


    },
    methods: {

      onGetMessage(){
        Service.onGetMessagr().then((response) => {
          this.message = response.data.data[0].DESCRIPTION;
        }).catch((error) => {

        })
      },
      onAUthen(){

        this.onClearData();
        var body = {};
        body.username = btoa(this.username);
        body.password = btoa(this.password);

        Service.onLogin(body).then((response) => {
          var decodedString = atob(response.data.token.split('.')[1]);
          var obj = JSON.parse(decodedString);

          if(response.data.status == "success"){
            this.$store.dispatch("setToken", response.data.token);
            this.$store.dispatch("setUser", obj.user_claims.data);
            this.$store.dispatch("setUsername", obj.user_claims.data.username);

            localStorage.setItem('token', response.data.token);
            localStorage.setItem('username', obj.user_claims.data.username);

            Service.onSetToken();
            this.onCheckgroup();
//
//            setTimeout(() => this.onCheckgroup(), 0);
          }
        }).catch((error) => {

          this.dialog = {
            message : error.response.data.msg,
            type : 'danger',
            style : 'modal-danger',
            status : true,
          }
        });
      },

      onCheckgroup(){

        Service.onCheckgroup().then((response) => {

          var obj = this.$store.state.user;
          obj.vtype = response.data.data[0].vtype;

          this.$store.dispatch("setUser", obj);
          localStorage.setItem('user', JSON.stringify(obj));
          // obj.vtype = "3"
          switch(obj.vtype){
            case "0":
              this.$router.push('/withdrow');
              break;
            case "1":
              this.$router.push('/instructors');
              break;
            case "2":
              this.$router.push('/dean');
              break;
            case "3":
              this.$router.push('/staff');
              break;
            case "4":
              this.$router.push('/dean');
              break;
          }

        }).catch((error) => {
          this.dialog = {
            message : error.response.message.en,
            type : 'danger',
            style : 'modal-danger',
            status : true,
          }
        });
      },
      onClearData(){
        this.$store.dispatch("setToken",null);
        this.$store.dispatch("setUser", null);
        this.$store.dispatch("setUsername", null);
      },

      onPlayerPlay (player) {
        console.log('player play!', player)
      },
      onPlayerReady (player) {
        console.log('player ready!', player)
        this.player.play()
      },
      playVideo: function (source) {
        const video = {
          withCredentials: false,
          type: 'application/x-mpegurl',
          src: source
        }
        this.player.reset() // in IE11 (mode IE10) direct usage of src() when <src> is already set, generated errors,
        this.player.src(video)
        // this.player.load()
        this.player.play()
      }

    },
    mounted() {

     this.onClearData();
     this.onGetMessage();

      // Your web app's Firebase configuration


    },
//    created () {
//
//    },

    computed: {
      player () {
        return this.$refs.videoPlayer.player
      }
    },
  }
</script>
